module.exports = __webpack_public_path__ + "img/GS_corpuls_white.3bb747c3.png";